import { __rest } from 'tslib';
import React from 'react';
import { styled } from '@mui/material/styles';
import { PeekBox } from '../PeekBox.js';
import { PeekStack } from '../PeekStack.js';
import { PeekLoader } from './PeekLoader.js';

const LoaderBox = styled((_a) => {
    var props = __rest(_a, ["layered"]);
    return React.createElement(PeekBox, Object.assign({}, props));
})(({ theme, layered }) => (Object.assign({ height: "100%", width: "100%", position: "fixed", top: 0, left: 0, zIndex: 999999 }, (layered && {
    opacity: 0.8,
    background: theme.palette.secondary.light,
}))));
const PeekScreenLoader = ({ layered, loaderImagePath }) => {
    return (React.createElement(LoaderBox, { layered: !!layered },
        React.createElement(PeekStack, { sx: { minHeight: "100vh" }, direction: "column", alignItems: "center", justifyContent: "center" },
            React.createElement(PeekLoader, { imagePath: loaderImagePath }))));
};

export { PeekScreenLoader, PeekScreenLoader as default };
